import { render, staticRenderFns } from "./DashboardWidgetStatoPatrimoniale.vue?vue&type=template&id=0e4acaa2&"
import script from "./DashboardWidgetStatoPatrimoniale.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetStatoPatrimoniale.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidgetStatoPatrimoniale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports